import StatusBar16ProMax from "../components/StatusBar16ProMax";
import ChatArea from "../components/ChatArea";
import HomeIndicator from "../components/HomeIndicator";

const SettingWifiDone1 = () => {
  return (
    <div className="w-full relative bg-light-primary-key-background overflow-hidden flex flex-col items-start justify-start gap-[59px] leading-[normal] tracking-[normal]">
      {/* <StatusBar16ProMax
        statusBar16ProMaxBackgroundColor="#fff"
        statusBar16ProMaxPosition="unset"
        statusBar16ProMaxTop="unset"
        statusBar16ProMaxLeft="unset"
      /> */}
      <main className="self-stretch flex flex-row items-start justify-start pt-0 px-10 pb-[18px] box-border max-w-full">
        <section className="flex-1 flex flex-col items-start justify-start gap-10 max-w-full text-left text-base text-light-text font-text-regular-lowercase mq330:gap-5">
          <div className="relative font-medium">Home</div>
          <ChatArea />
        </section>
      </main>
      {/* <HomeIndicator
        homeIndicatorBackgroundColor="#fff"
        homeIndicatorMargin="unset"
        homeIndicatorPosition="unset"
        homeIndicatorRight="unset"
        homeIndicatorBottom="unset"
        homeIndicatorLeft="unset"
        homeIndicatorTop="unset"
        homeIndicatorMarginTop="unset"
      /> */}
    </div>
  );
};

export default SettingWifiDone1;
